export default {"src":"/_next/static/media/plus-icon.3d079a5a.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};